import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0786299e&lang=pug"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0786299e')) {
      api.createRecord('0786299e', component.options)
    } else {
      api.reload('0786299e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0786299e&lang=pug", function () {
      api.rerender('0786299e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/admin-controls/Index.vue"
export default component.exports